var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLevel3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 149,
    viewBox: "0 0 100 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.2644 5.34351L63.0377 3.81679V8.52672L58.4288 7V1.52672L52.2022 0V6.23664H47.5856V0L41.359 1.52672V7L36.7501 8.52672V3.81679L30.5234 5.34351L30.7447 33.3664H69.0431L69.2644 5.34351Z",
    fill: "#868694"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8893 37.3438C60.4672 37.3438 69.0423 35.5632 69.0423 33.3667C69.0423 31.1703 60.4672 29.3896 49.8893 29.3896C39.3114 29.3896 30.7363 31.1703 30.7363 33.3667C30.7363 35.5632 39.3114 37.3438 49.8893 37.3438Z",
    fill: "#4B4B4B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 119.305L50.0038 148.183L100 119.305V61.5496L50.0038 32.6641L0 61.5496V119.305Z",
    fill: "url(#paint0_linear_1729_183)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5186 107.385C48.9835 107.385 47.5081 107.146 46.0922 106.669C44.6764 106.192 43.3946 105.499 42.2471 104.589C41.1144 103.68 40.1904 102.502 39.475 101.056C38.7596 99.5946 38.3721 97.962 38.3125 96.158H45.1756C45.3247 97.6042 45.8687 98.7 46.8076 99.4455C47.7465 100.176 48.9835 100.541 50.5186 100.541C51.845 100.541 52.9181 100.213 53.7378 99.5573C54.5575 98.9013 54.9822 98.044 55.0121 96.9854C55.0419 95.8225 54.6097 94.8758 53.7154 94.1452C52.8361 93.4147 51.6662 93.0494 50.2056 93.0494H47.3665V87.5031H49.8479C51.234 87.5031 52.2772 87.1825 52.9777 86.5414C53.6931 85.9003 54.0657 85.0431 54.0955 83.9696C54.1104 83.0005 53.7601 82.2028 53.0448 81.5766C52.3294 80.9355 51.4426 80.615 50.3845 80.615C49.0431 80.615 47.9403 81.0175 47.0759 81.8226C46.2263 82.6277 45.8165 83.5894 45.8463 84.7076H38.9385C38.9385 83.0377 39.2663 81.5021 39.9221 80.1006C40.5779 78.6991 41.4497 77.5511 42.5377 76.6565C43.6257 75.7471 44.8478 75.0463 46.204 74.5543C47.5602 74.0474 48.9537 73.7939 50.3845 73.7939C52.0686 73.7939 53.5962 74.0549 54.9673 74.5767C56.3385 75.0985 57.4563 75.7993 58.3207 76.6789C59.2 77.5586 59.8706 78.5724 60.3327 79.7204C60.8096 80.8684 61.048 82.0835 61.048 83.3657C61.048 84.8418 60.7202 86.1985 60.0644 87.436C59.4086 88.6735 58.6113 89.6575 57.6724 90.3881C58.8796 90.9695 59.893 91.8864 60.7127 93.1388C61.5473 94.3763 61.9646 95.8523 61.9646 97.5669C61.9646 100.444 60.9065 102.8 58.7901 104.634C56.6887 106.468 53.9315 107.385 50.5186 107.385Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1729_183",
    x1: 50,
    y1: 32.6641,
    x2: 50,
    y2: 148.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E7E8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7B7CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel3);
export default __webpack_public_path__ + "static/media/_level-3.840550bd84051315957ca95c3ca1a375.svg";
export { ForwardRef as ReactComponent };